<template>
  <div>
    <div class="previewImg" v-show="previewImg" @click="previewImg = ''">
      <img :src="previewImg" alt="" />
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
    >
      <el-form-item label="模板名称" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item
        label="模板类型"
        v-if="showTemplateType && showTemplateStyleId"
        prop="templateType"
      >
        <el-select
          v-model="ruleForm.templateType"
          placeholder="请选择模板类型"
          @change="templateTypeChange"
        >
          <el-option
            v-for="item in tempOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模板风格" prop="templateStyleId">
        <el-radio-group
          v-model="ruleForm.templateStyleId"
          @change="templateStyleChange"
          class="templateStyle"
        >
          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide
              class="box-slide"
              v-for="(item, index) in templateStyleList"
              :key="index"
            >
              <el-radio :label="item.id" class="templateStyle__radio">
                <div class="templateStyle__item">
                  <span
                    v-if="item.coverImg"
                    class="templateStyle__item__preview"
                    @click.stop.prevent="preview(item)"
                    title="预览"
                  >
                    预览
                  </span>
                  <div class="templateStyle__item__img">
                    <img :src="item.coverImg" alt="" />
                  </div>
                  <div class="templateStyle__item__name">
                    <el-radio
                      v-model="ruleForm.templateStyleId"
                      :label="item.id"
                      ><span :title="item.name">{{ item.name }}</span></el-radio
                    >
                  </div>
                </div>
              </el-radio>
            </swiper-slide>
          </swiper>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="模板语种" prop="language">
        <el-select
          class="templateLanguage"
          v-model="ruleForm.language"
          placeholder="请选择模板语种"
        >
          <el-option label="中文" :value="1"></el-option>
          <el-option label="英文" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-for="(item, index) in schemaConfig"
        :key="index"
        :prop="item.code"
        :label="item.name"
        :rules="[
          {
            required: item.required,
            message: messageText(item),
            trigger: 'blur'
          }
        ]"
      >
        <!-- 单行文本 -->
        <el-input
          v-if="item.type === 'text'"
          is="el-input"
          type="text"
          v-model="ruleForm[item.code]"
          :placeholder="`请输入${item.name}`"
        />
        <!-- 多行文本 -->
        <el-input
          v-if="item.type === 'textarea'"
          is="el-input"
          type="textarea"
          v-model="ruleForm[item.code]"
          :placeholder="`请输入${item.name}`"
          :rows="4"
        />
        <!-- 富文本 -->
        <editor
          v-if="item.type === 'richtext'"
          :init="init"
          model-events="change keydown blur focus paste"
          v-model="ruleForm[item.code]"
          :tinymce-script-src="
            $micro.WEBPACK_PUBLIC_PATH + 'static/tinymce/tinymce.min.js'
          "
        />
        <!-- 图片上传 -->
        <el-upload
          v-if="item.type === 'image'"
          class="uploadImg"
          :action="uploadUrl"
          :before-upload="beforeImageUpload"
          :show-file-list="false"
          :on-success="(res) => handleImageSuccess(res, item)"
        >
          <div slot="trigger">
            <div class="uploadImg__content">
              <img :src="item.imgUrl || morImg" alt="" />
              <i
                v-if="item.imgUrl"
                class="el-icon-circle-close uploadImg__remove"
                @click.stop.prevent="handleRemoveImage(item)"
              ></i>
            </div>
          </div>
          <div slot="tip" class="el-upload__tip" v-if="item.tips">
            {{ item.tips }}
          </div>
        </el-upload>
        <!-- 颜色 -->
        <el-color-picker
          v-if="item.type === 'color'"
          v-model="ruleForm[item.code]"
        />
        <!-- 单选 -->
        <el-radio-group
          v-if="item.type === 'radio'"
          v-model="ruleForm[item.code]"
        >
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { Get, Post, ProjectConfig } from '@/api'
import Editor from '@tinymce/tinymce-vue'
const increment = ProjectConfig.increment
import { mapGetters } from 'vuex'
export default {
  name: 'TemplateStyle',
  props: {
    // 是否显示模板类型
    showTemplateType: {
      type: Boolean,
      default: true
    },
    showTemplateStyleId: {
      type: Boolean,
      default: true
    },
    templateOptions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(['isMedicalAssociationEnv'])
  },
  components: { Editor },
  data() {
    return {
      morImg: require('@/assets/img/img_default.png'),
      templateStyleList: [],
      ruleForm: {
        name: '',
        templateStyleId: '',
        templateType: 1,
        language: 1
      },
      rules: {
        name: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
        templateType: [
          { required: true, message: '请选择模板类型', trigger: 'change' }
        ],
        templateStyleId: [
          { required: true, message: '请选择模板风格', trigger: 'change' }
        ],
        language: [
          { required: true, message: '请选择模板语种', trigger: 'change' }
        ]
      },
      tempOptions: [],
      schemaConfig: [],
      uploadUrl: increment.UploadTemplateConfig.url,
      init: {
        auto_focus: false,
        min_height: 400,
        menubar: false,
        language: 'zh_CN',
        skin: 'CUSTOM',
        content_css: 'CUSTOM',
        convert_urls: false,
        paste_data_images: true,
        paste_auto_cleanup_on_paste: true,
        plugins:
          'quickbars print preview searchreplace autolink directionality visualblocks visualchars fullscreen template code codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount imagetools textpattern help link emoticons autosave indent2em lineheight formatpainter image paste',
        toolbar:
          'fontselect fontsizeselect bullist numlist outdent indent indent2em formatselect table formatpainter bold italic underline strikethrough superscript subscript removeformat forecolor backcolor alignleft aligncenter alignright alignjustify lineheight link undo redo image code',
        toolbar_mode: 'sliding',
        quickbars_selection_toolbar:
          'bold italic underline strikethrough subscript superscript removeformat',
        quickbars_insert_toolbar: false,
        fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
        font_formats:
          '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;宋体=simsun,serif,sans-serif;仿宋体=FangSong,serif,sans-serif;楷体=KaiTi,serif,sans-serif;黑体=SimHei,sans-serif;隶书=LiSu,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Times New Roman=Times New Roman,helvetica,sans-serif;',
        images_upload_handler: this.uploadImage,
        setup: (editor) => {
          editor.on('paste_postprocess', (args) => {
            const node = args.node
            const images = node.querySelectorAll('img')

            images.forEach(async (img) => {
              const src = img.getAttribute('src')
              if (src && src.startsWith('data:image')) {
                try {
                  const uploadedUrl = await this.uploadBase64Image(src)
                  if (uploadedUrl) {
                    img.setAttribute('src', uploadedUrl)
                  }
                } catch (error) {
                  console.error('粘贴图片上传失败:', error)
                  img.parentNode?.removeChild(img)
                }
              }
            })
          })
        }
      },
      swiperOptions: {
        loop: true,
        slidesPerView: 5, // 显示个数
        spaceBetween: 10,
        direction: 'horizontal',
        grabCursor: true,
        touchStartPreventDefault: false
      },
      previewImg: '',
      target: null
    }
  },
  watch: {
    templateOptions: {
      handler(newVal) {
        if (newVal && newVal.length) {
          this.tempOptions = [...newVal]
          this.ruleForm.templateType = this.tempOptions[0].value
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (this.showTemplateStyleId) {
      this.GetTemplateStyleList(this.ruleForm.templateType)
    }
  },
  mounted() {},
  methods: {
    setData(data) {
      this.target = data
      this.ruleForm.templateType = data.type
      this.ruleForm.templateStyleId = data.templateStyleId
      this.GetTemplateStyleList(this.ruleForm.templateType)
    },
    preview(item) {
      if (item.coverImg) {
        this.previewImg = item.coverImg
      }
    },
    handleImageSuccess(res, item) {
      if (res.data.success) {
        this.ruleForm[item.code] = res.data.ID
        this.$set(item, 'imgUrl', this.getImgPath(res.data.ID))
        this.$message.success('上传成功')
      }
    },
    handleRemoveImage(item) {
      this.$set(item, 'imgUrl', '')
      this.ruleForm[item.code] = ''
    },
    uploadImage(blobInfo, succFun, failure) {
      const file = blobInfo.blob()
      console.log(file, 'file')
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isLt2M) {
        failure('上传图片大小不能超过 1MB!')
        return
      }
      const myForm = new FormData()
      myForm.append('file', file)
      Post(increment.UploadTemplateConfig.url, myForm)
        .then((resp) => {
          const { status, data } = resp.data
          if (status !== 0) {
            failure(data.message || '上传失败')
            return false
          }
          if (data.Url) {
            succFun(data.Url)
          } else {
            failure('未获取到图片url')
          }
        })
        .catch((error) => {
          console.error('上传图片失败:', error)
          failure('上传失败')
        })
    },
    uploadBase64Image(base64Src) {
      return new Promise((resolve, reject) => {
        try {
          const arr = base64Src.split(',')
          const type = arr[0].match(/:(.*?);/)[1]
          const bstr = atob(arr[1])
          let n = bstr.length
          const u8arr = new Uint8Array(n)
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }
          const file = new File(
            [u8arr],
            `paste_image_${Date.now()}.${type.split('/')[1]}`,
            {
              type: type
            }
          )

          const isLt2M = file.size / 1024 / 1024 < 10
          if (!isLt2M) {
            this.$message.error('粘贴图片大小不能超过 10MB!')
            reject(new Error('图片大小超过限制'))
            return
          }

          const myForm = new FormData()
          myForm.append('file', file)

          Post(increment.UploadTemplateConfig.url, myForm)
            .then((resp) => {
              const { status, data } = resp.data
              if (status !== 0) {
                this.$message({
                  type: 'error',
                  message: '图片上传失败'
                })
                reject(new Error('上传失败'))
                return
              }
              if (data.Url) {
                resolve(data.Url)
              } else {
                this.$message({
                  type: 'error',
                  message: '未获取到图片url'
                })
                reject(new Error('未获取到图片url'))
              }
            })
            .catch((error) => {
              console.error('上传图片失败:', error)
              this.$message.error('图片上传失败')
              reject(error)
            })
        } catch (error) {
          console.error('处理base64图片失败:', error)
          reject(error)
        }
      })
    },
    // 提示语
    messageText(item) {
      let str = ''
      if (['text', 'textarea', 'richtext'].includes(item.type)) {
        str = `请输入${item.name}`
      } else if (item.type === 'image') {
        str = `请上传${item.name}`
      } else if (['color', 'radio'].includes(item.type)) {
        str = `请选择${item.name}`
      }
      return str
    },
    handleImageChange() {},
    beforeImageUpload(file) {
      // 图片大小限制为 1M
      const MAX_SIZE = 1 * 1024 * 1024
      if (file.size > MAX_SIZE) {
        this.$message.error('您上传的图片过大，请将图片按建议调整后再次上传')
        return false
      }
      return true
    },
    // 重置表单
    resetForm() {
      Object.keys(this.ruleForm).forEach((key) => {
        if ('templateType' === key) {
          return
        }
        if (['language'].includes(key)) {
          this.ruleForm[key] = 1
        } else {
          this.ruleForm[key] = ''
        }
      })
    },
    // 模板类型改变时，重置表单并获取模板风格列表
    templateTypeChange() {
      // this.resetForm()
      this.GetTemplateStyleList(this.ruleForm.templateType)
    },
    // 模板风格切换
    templateStyleChange(id, isLoad) {
      let data = this.templateStyleList.find((item) => item.id === id)
      // data.schemaConfig = null
      if (data && data.schemaConfig) {
        try {
          this.schemaConfig = JSON.parse(data.schemaConfig).map((item) => {
            if (!this.ruleForm[item.code]) {
              this.$set(this.ruleForm, item.code, '')
            }
            if (['radio', 'richtext', 'text'].includes(item.type)) {
              this.$set(this.ruleForm, item.code, item.value)
            }
            // #D9001B
            if (item.type === 'color') {
              if (!this.ruleForm[item.code]) {
                this.$set(
                  this.ruleForm,
                  item.code,
                  this.isMedicalAssociationEnv ? '#D9001B' : '#4054af'
                )
              }
            }
            return {
              ...item
            }
          })
          console.log(this.schemaConfig, 'schemaConfig')
        } catch (error) {
          console.error('解析 JSON 时出现错误：', error)
        }
      } else {
        this.schemaConfig = []
      }
      if (!this.showTemplateStyleId) {
        console.log(this.ruleForm, 'ruleForm')
        Object.keys(this.ruleForm).forEach((key) => {
          if (['templateStyleId'].includes(key)) {
            return
          } else if (['templateType'].includes(key)) {
            this.ruleForm[key] = this.target.type
          } else {
            let findData = this.schemaConfig.find((it) => it.code === key)
            if (findData && findData.type === 'image') {
              this.$set(findData, 'imgUrl', this.getImgPath(this.target[key]))
            }
            // console.log(findData, 'findData')
            // // 图片类型的code需要获取图片地址
            // if (['qrCodeId'].includes(key)) {
            //   if (this.schemaConfig) {
            //     let findData = this.schemaConfig.find((it) => it.code === key)
            //     if (findData) {
            //       this.$set(
            //         findData,
            //         'imgUrl',
            //         this.getImgPath(this.target[key])
            //       )
            //     }
            //   }
            // }
            // if (!this.ruleForm[key]) {
            if (isLoad) {
              this.ruleForm[key] = this.target[key]
            }
            // }
          }
        })
      }
    },
    async GetTemplateStyleList(type) {
      let params = {
        type: type
      }
      let res = await Get(increment.GetTemplateStyleList.url, { params })
      if (res.data.status === 0 && res.data.data.content.length) {
        this.templateStyleList = res.data.data.content.map((item) => {
          return {
            ...item,
            coverImg: this.getImgPath(item.thumbnailId)
          }
        })
        if (this.showTemplateStyleId) {
          this.ruleForm.templateStyleId = this.templateStyleList[0].id
        }
        this.templateStyleChange(this.ruleForm.templateStyleId, true)
      } else {
        if (this.showTemplateStyleId) {
          this.ruleForm.templateStyleId = ''
        }
        this.schemaConfig = []
        this.templateStyleList = []
      }
    },
    getImgPath(id) {
      if (!id) return ''
      return increment.GetConfigPicture.url + '?pictureId=' + id
    }
  }
}
</script>

<style lang="scss" scoped>
.templateStyle {
  width: 100%;
  &__radio {
    > ::v-deep .el-radio__input {
      display: none;
    }
  }
  &__item {
    width: 150px;
    overflow: hidden;
    position: relative;
    &__preview {
      width: 30px;
      height: 18px;
      font-size: 12px;
      position: absolute;
      top: 0;
      right: 0;
      background: #c7cef4;
      color: #4054af;
      text-align: center;
      line-height: 18px;
    }
    &__img {
      width: 150px;
      height: 200px;
      background: #f4f4f4;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 5px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        -webkit-user-drag: none;
        -moz-user-drag: none;
        -ms-user-drag: none;
        user-drag: none;
      }
    }
    &__name {
      padding: 5px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.templateLanguage {
  width: 200px;
}
.previewImg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  overflow: auto;
  img {
    max-width: 80%;
  }
}
.uploadImg {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  .el-upload__tip {
    line-height: 1;
    color: #999;
  }
  &__content {
    width: 120px;
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ddd;
    background: #f4f4f4;
    position: relative;
    img {
      max-width: 100%;
      object-fit: contain;
    }
  }
  &__remove {
    position: absolute;
    top: -6px;
    right: -6px;
    font-size: 18px;
    color: #909399;
    background: #fff;
    border-radius: 50%;
    cursor: pointer;
    &:hover {
      color: #f56c6c;
    }
  }
}
</style>
